import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { authActions } from 'features/anonymousAuth'
import { getAuth, onAuthStateChanged, signInAnonymously } from 'firebase/auth'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
    loadCurrentProfile,
    loadMinecardsSessionProfile,
} from '../model/loadCurrentProfile'
import React from 'react'
import { BackendApiError } from 'shared/api/minecardsBackendClient'
import { BACKEND_DATA_SOURCE, selectDataSource } from 'shared/api/dataSource'
import {
    exchangeFirebaseSession,
    sessionChangedEvent,
} from 'shared/api/sessionAuth'

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch()

    useEffect(() => {
        let active = true
        let signInStarted = false

        const applyProfile = (profile, uid) => {
            if (!active) {
                return
            }
            dispatch(authActions.setUserData(profile))
            dispatch(authActions.setUid(uid))
        }

        const restoreOwnSession = async () => {
            try {
                const profile = await loadMinecardsSessionProfile()
                if (!profile) {
                    return false
                }
                applyProfile(profile, 'minecards-session')
                return true
            } catch (error) {
                if (
                    !(error instanceof BackendApiError && error.status === 401)
                ) {
                    console.error('MineCards session restore failed', error)
                }
                return false
            }
        }

        const reloadOwnSession = async () => {
            if (!(await restoreOwnSession()) && active) {
                dispatch(authActions.setSignedOut())
            }
        }
        window.addEventListener(sessionChangedEvent, reloadOwnSession)

        if (selectDataSource(null) === BACKEND_DATA_SOURCE) {
            reloadOwnSession()
            return () => {
                active = false
                window.removeEventListener(
                    sessionChangedEvent,
                    reloadOwnSession
                )
            }
        }

        const auth = getAuth(app)

        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (await restoreOwnSession()) {
                return
            }
            if (!user) {
                if (signInStarted) {
                    return
                }
                signInStarted = true
                try {
                    await signInAnonymously(auth)
                } catch (error) {
                    signInStarted = false
                    console.error('Anonymous sign-in failed', error)
                }
                return
            }

            signInStarted = false
            try {
                const profile = await loadCurrentProfile(user)
                try {
                    await exchangeFirebaseSession(user)
                } catch (error) {
                    console.error('Firebase session exchange failed', error)
                }
                applyProfile(profile, user.uid)
            } catch (error) {
                console.error('Profile initialization failed', error)
            }
        })

        return () => {
            active = false
            window.removeEventListener(sessionChangedEvent, reloadOwnSession)
            unsubscribe()
        }
    }, [dispatch])

    return <>{children}</>
}
